import { useQuery } from '@tanstack/react-query';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { me } from './lib/api.ts';
import { Dashboard } from './screens/Dashboard.tsx';
import { Detail } from './screens/Detail.tsx';
import { Holdings } from './screens/Holdings.tsx';
import { Login } from './screens/Login.tsx';
import { Signup } from './screens/Signup.tsx';

const PUBLIC_ROUTES = new Set(['/login', '/signup']);

export function App() {
  // Auth gate at the App level. Public routes: /login, /signup.
  // /api/me is hit on every mount; SWR within QueryClient avoids a flicker on revisit.
  const meQ = useQuery({
    queryKey: ['me'],
    queryFn: me,
    staleTime: 60_000,
    retry: false,
    refetchInterval: false,
  });

  const location = useLocation();
  if (meQ.isLoading) return <div className="screen" />;
  const authed = meQ.data?.authenticated === true;

  if (!authed && !PUBLIC_ROUTES.has(location.pathname)) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/" element={<Dashboard />} />
      <Route path="/holdings" element={<Holdings />} />
      <Route path="/card/:id" element={<Detail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
